module.exports = __webpack_public_path__ + "img/dashboard-details-bg.7ca17a2a.svg";